import React, { forwardRef } from "react"
import { useSearchParams } from "react-router-dom"

import Button from "@fuse/sharedComponents/buttons/SolidBtn"
import { isEmpty } from "lodash-es"

import { TExploreSearchArgs } from "@fuse/pages/explore"
import { getThePreciseLocation } from "@fuse/pages/explore/utility/locationFunctions"

import EyeGif from "@fuse/assets/gif/gif-eyes.gif"

interface EmptySearchStateProps {
  onClickOfChangeLocation: () => void
}

const EmptySearchState = forwardRef<HTMLDivElement, EmptySearchStateProps>(
  ({ onClickOfChangeLocation }, ref) => {
    const [_, setSearchParams] = useSearchParams()
    const setQueryInUrl = (data: TExploreSearchArgs) => {
      const queryObj = Object.entries(data).reduce((acc, [key, val]) => {
        const keyToProcess = key as keyof TExploreSearchArgs
        if (!isEmpty(val)) {
          switch (keyToProcess) {
            case "location": {
              const valueToProcess = val as TExploreSearchArgs["location"]
              if (valueToProcess?.lat || valueToProcess?.lon) {
                acc["location"] = `${valueToProcess.lat},${valueToProcess.lon}`
              }
              break
            }
          }

          return acc
        } else {
          return acc
        }
      }, {})
      setSearchParams(queryObj)
    }
    const handleUseCurrentLocation = () => {
      getThePreciseLocation(setQueryInUrl)
    }
    return (
      <div className="py-10 flex flex-col justify-center items-center gap-4 md:gap-6 lg:gap-10 ">
        <img src={EyeGif} className="w-32 aspect-square portrait:w-16 " />
        <div className="flex flex-col gap-2 md:gap-4">
          <div className=" text-md sm:text-lg md:text-xl lg:text-2xl text-white font-semibold ">
            See what’s on near you
          </div>
          <div className="text-sm sm:text-base md:text-md lg:text-lg  text-[#ffffff80] ">
            Find out what’s happening in your area
          </div>
        </div>

        <div className="flex flex-col gap-2 md:gap-4 ">
          <Button
            variant="solid"
            className="!hover:cursor-pointer"
            onClick={handleUseCurrentLocation}
          >
            <div className="px-8 text-base sm:text-md md:text-lg lg:text-xl">
              Use current location
            </div>
          </Button>
          <div
            ref={ref}
            onClick={onClickOfChangeLocation}
            className="px-8 text-[white] font-semibold hover:cursor-pointer text-base sm:text-md md:text-lg lg:text-xl"
          >
            Choose location
          </div>
        </div>
      </div>
    )
  },
)

export default EmptySearchState
